import { useState } from "react";
import { BiChevronDown } from "react-icons/bi";
function SidebarItem({ icon, text, children }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div>
            <div className="sidebar-menu-item" onClick={toggleOpen}>
                {icon}
                <span className="sidebar-menu-item-text">{text}</span>
                <BiChevronDown
                    className={`sidebar-menu-toggle sidebar-menu-item-icon ${
                        isOpen ? "rotate-180" : "rotate-back"
                    }`}
                />
            </div>
            {isOpen && children}
        </div>
    );
}

export default SidebarItem;
